import React, { Component, Fragment } from 'react';

import type { Scheme } from '../types/configs';

class MenuButton extends Component<
  { scheme: Scheme; toggleMenuState: (...args: any[]) => void; show: boolean },
  unknown
> {
  toggleMenuState = () => {
    const { toggleMenuState } = this.props;
    toggleMenuState();
  };

  render() {
    const {
      show,
      scheme: {
        header: { messageBarColor },
      },
    } = this.props;
    return (
      <>
        {show && (
          <button
            type='button'
            className='menu-button'
            style={{ backgroundColor: messageBarColor }}
            onClick={this.toggleMenuState}>
            <i className='fas fa-bars' />
          </button>
        )}
      </>
    );
  }
}

export default MenuButton;
